/**
 * systemDataApi — typed fetch helpers for /api/system/*.
 *
 * Pulls the boot-time static catalogs (elements + synergies) so the
 * Encyclopedia's Rules tab can render them without bundling at build
 * time. Schema lives in `@origami/shared` (ElementsConfig + SynergyDef).
 */
import type { ElementsConfig, SynergyDef } from '@origami/shared'

export async function fetchElements(): Promise<ElementsConfig> {
  const res = await fetch('/api/system/elements', { credentials: 'include' })
  if (!res.ok) throw new Error(`elements HTTP ${res.status}`)
  return (await res.json()) as ElementsConfig
}

export async function fetchSynergies(): Promise<SynergyDef[]> {
  const res = await fetch('/api/system/synergies', { credentials: 'include' })
  if (!res.ok) throw new Error(`synergies HTTP ${res.status}`)
  return (await res.json()) as SynergyDef[]
}
